"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeferredPaymentDisplayStatus = exports.DEFERRED_PAYMENT_DISPLAY_RULES = void 0;
const command_1 = require("../enums/command");
const common_1 = require("../enums/common");
const payment_1 = require("../enums/payment");
exports.DEFERRED_PAYMENT_DISPLAY_RULES = [
    {
        status: common_1.PaymentStatus.Created,
        paymentMethod: payment_1.PaymentMethod.Daf,
        commandStatus: command_1.CommandStatus.Complete,
        displayStatus: "toConfirm",
    },
    { status: common_1.PaymentStatus.Processing, paymentMethod: payment_1.PaymentMethod.Daf, displayStatus: "due" },
    { status: common_1.PaymentStatus.Processing, paymentMethod: payment_1.PaymentMethod.Cheque, displayStatus: "due" },
    { status: common_1.PaymentStatus.Processing, paymentMethod: payment_1.PaymentMethod.Cash, displayStatus: "due" },
];
const getDeferredPaymentDisplayStatus = (payment) => exports.DEFERRED_PAYMENT_DISPLAY_RULES.find((rule) => rule.status === payment.status &&
    rule.paymentMethod === payment.paymentMethod &&
    (!("commandStatus" in rule) || rule.commandStatus === payment.commandStatus))?.displayStatus ?? null;
exports.getDeferredPaymentDisplayStatus = getDeferredPaymentDisplayStatus;
